/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_norm_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Both are printed on the reagent bottle. Density (specific gravity) is given in g/mL and the assay or purity as a percentage.`)
};

const es_norm_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ambos están impresos en el envase del reactivo. La densidad (gravedad específica) se da en g/mL y el ensayo o pureza como porcentaje.`)
};

const de_norm_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beide sind auf der Reagenzflasche aufgedruckt. Die Dichte (spezifisches Gewicht) wird in g/mL angegeben und der Gehalt oder die Reinheit als Prozentsatz.`)
};

const nl_norm_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beide staan op het etiket van de reagensfles. Dichtheid (soortelijk gewicht) wordt gegeven in g/mL en het gehalte of de zuiverheid als percentage.`)
};

const fr_norm_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les deux sont imprimés sur le flacon du réactif. La densité (gravité spécifique) est donnée en g/mL et le titre ou la pureté en pourcentage.`)
};

const it_norm_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrambi sono stampati sull'etichetta del reagente. La densità (peso specifico) è espressa in g/mL e il titolo o purezza come percentuale.`)
};

const pt_br2_norm_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ambos estão impressos no rótulo do frasco do reagente. A densidade (densidade relativa) é dada em g/mL e o teor ou pureza como percentual.`)
};

const pt_norm_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ambos estão impressos no rótulo do reagente. A densidade (densidade específica) é dada em g/mL e o título ou pureza como percentagem.`)
};

const ja_norm_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`どちらも試薬ボトルに記載されています。密度（比重）はg/mLで、アッセイまたは純度はパーセンテージで示されます。`)
};

const zh_norm_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`两者都印在试剂瓶标签上。密度（比重）以 g/mL 给出，含量或纯度以百分比给出。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const norm_faq_a3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.norm_faq_a3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("norm_faq_a3", locale)
	if (locale === "en") return en_norm_faq_a3(inputs)
	if (locale === "es") return es_norm_faq_a3(inputs)
	if (locale === "de") return de_norm_faq_a3(inputs)
	if (locale === "nl") return nl_norm_faq_a3(inputs)
	if (locale === "fr") return fr_norm_faq_a3(inputs)
	if (locale === "it") return it_norm_faq_a3(inputs)
	if (locale === "pt-BR") return pt_br2_norm_faq_a3(inputs)
	if (locale === "pt") return pt_norm_faq_a3(inputs)
	if (locale === "ja") return ja_norm_faq_a3(inputs)
	return zh_norm_faq_a3(inputs)
};